import React from 'react'
import {DefaultProps, RefTable} from "../RefTable";
import {customsLatestReport, customsReportSplits} from "../../api/api";
import {Button, notification} from "antd";

const DownloadReport = (props) => {
    const [month, setMonth] = React.useState()
    React.useEffect(() => {
        const {effective_month} = props.data.filter(x => x.customs_id === props.customs_id)[0] || {}
        setMonth(effective_month)
    }, [])
    return <Button disabled={!month} onClick={async () => {
        try {
            await props.onDownload(month);
        } catch (err) {
            notification.error({message: "Report generation failed"});
        }
    }}>Download</Button>
}


export const Customs = (props)=><RefTable {...props}/>;

Customs.defaultProps = {
    ...DefaultProps,
    tableName: "customs",
    tableSchema: "customs",
    edit: true,
    title: "Customs",
    theadHeight: 62,
    tfootHeight: 50,
    enrichColumns: async (columns) => {
        const {data: {rows: data = []}} = await customsLatestReport()
        return [
            {
                name: "id",
                title: "Latest Handled Order Report",
                width: 120,
                formatter: (row, index) => <DownloadReport key={index} data={data} customs_id={row.id}
                                                           onDownload={async (m) => customsReportSplits(row.id, m)}/>
            }, ...columns]
    }
}


